import React from 'react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-slate-950 text-white px-4 py-12">
      <div className="max-w-3xl mx-auto space-y-4">
        <h1 className="text-3xl font-bold text-purple-100">Contact</h1>
        <p className="text-purple-200">
          Reach out to the team for collaboration, support, or demo requests. A full contact form and team directory will live here soon.
        </p>
      </div>
    </div>
  );
};

export default Contact;
